<template>
  <div id="app">
     <!-- embed the nav component -->
    <Nav />
    <router-view/>
  </div>
</template>

<script>
//Import the nav component so that embedding can be successfully done
import Nav from './components/partials/Nav.vue';
export default {
   name: 'app',
    components: {
    Nav
  } 
  
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;
    padding-left:10px;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
